export type PhoneValue = string | number | null | undefined;

/**
 * Normalizes Russian phone numbers for links and consistent display.
 *
 * Supported local prefixes:
 * - 965...  -> +7965...
 * - 8965... -> +7965...
 * - 7965... -> +7965...
 */
export const formatInternationalPhone = (phone: PhoneValue): string | null => {
  const digits = String(phone ?? "").replace(/\D/g, "");

  if (!digits) return null;

  if (digits.length === 10) {
    return `+7${digits}`;
  }

  if (
    digits.length === 11 &&
    (digits.startsWith("7") || digits.startsWith("8"))
  ) {
    return `+7${digits.slice(1)}`;
  }

  return `+${digits}`;
};

export const formatPhoneForDisplay = (phone: PhoneValue): string | null => {
  const normalizedPhone = formatInternationalPhone(phone);
  const russianPhoneMatch = normalizedPhone?.match(
    /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/,
  );

  if (!russianPhoneMatch) return normalizedPhone;

  const [, areaCode, firstPart, secondPart, lastPart] = russianPhoneMatch;
  return `+7 ${areaCode} ${firstPart}-${secondPart}-${lastPart}`;
};

export const getPhoneHref = (phone: PhoneValue): string | null => {
  const normalizedPhone = formatInternationalPhone(phone);
  return normalizedPhone ? `tel:${normalizedPhone}` : null;
};
